import http, { CancelToken } from './http';

export let cancelRequest = undefined;

const gisAPI = {
  getGisSuggestions(query) {
    let source = CancelToken.source();
    return http.get('gis/',
      {
        params: { q: query },
        cancelToken: new CancelToken(function executor(c) { cancelRequest = c; })
      }
    )
    .then(
      function(success) { return success },
      function(error) { }
    )
  }
};

export default gisAPI;

